// Cart reminder - PE (Halloween clock - PE, Sasha 2026-10-09) §4 — a quiet
// "your cart is waiting" note for a RETURNING visitor
// (snippets/paex-cart-reminder.liquid; rendered only while the clock runs
// and the theme setting paex_clock_reminder_enabled is on).
//   returning = this tab's session has no 'paex:visit' yet AND localStorage
//   'paex:lastseen' is more than 30 min old (stamped on every page, and
//   again when the page is hidden); once per visit ('paex:reminder:shown');
//   cart count from paexClock.config.cart.count (> 0).
//   Copy, from the shared clock (dates for the SLOWEST cart line — the
//   drawer's script[data-paex-cart-edd-data] edd.processing, else the theme
//   default):
//     ontime / lastday → reminder {date} + "View cart" (opens the drawer)
//     late             → reminder_late_generic ("visit our stores") — never
//                        a store name: this note has no store stock data
//     unknown          → nothing (never a promise on a guess)
// Fixed overlay (0 px in the flow): bottom on mobile, lifted above the PDP
// sticky bar and the toasts; top-right under the header on desktop. Every
// storage access is guarded (private mode / blocked storage = no reminder).
// A11y: Escape (document-level, bound only while shown) dismisses; hiding
// with focus inside hands focus to the cart icon (else #MainContent); on
// mobile the page gets bottom scroll-padding while the note is up, so a
// focused field is never scrolled in under it.

(function () {
  if (window.paexCartReminder) return;
  window.paexCartReminder = true;

  var GAP_MS = 30 * 60000;

  function store(name) {
    try { return window[name] || null; } catch (error) { return null; }
  }
  function read(name, key) {
    var s = store(name);
    try { return s ? s.getItem(key) : null; } catch (error) { return null; }
  }
  function write(name, key, value) {
    var s = store(name);
    try { if (s) s.setItem(key, value); } catch (error) { /* storage blocked */ }
  }

  // decided ONCE, before this page stamps its own visit
  var now = Date.now();
  var lastSeen = Number(read('localStorage', 'paex:lastseen')) || 0;
  var returning = read('sessionStorage', 'paex:visit') == null
    && lastSeen > 0 && now - lastSeen > GAP_MS
    && read('sessionStorage', 'paex:reminder:shown') == null;
  write('sessionStorage', 'paex:visit', '1');
  write('localStorage', 'paex:lastseen', String(now));
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) write('localStorage', 'paex:lastseen', String(Date.now()));
  });

  if (!returning) return;

  function el() {
    return document.querySelector('[data-paex-reminder]');
  }

  // processing days of the slowest cart line, as the drawer resolved them
  function slowestProcessing() {
    var node = document.querySelector('script[data-paex-cart-edd-data]');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      var processing = parseInt(data && data.edd && data.edd.processing, 10);
      return processing >= 0 ? Math.min(processing, 30) : null;
    } catch (error) {
      return null;
    }
  }

  // mobile: clear of the PDP sticky bar and any toast; desktop: under the header
  function place(box) {
    var lift = 0;
    var sticky = document.querySelector('.section-main-product .product-mini-checkout.position--bottom');
    if (sticky) lift = Math.max(lift, Math.round(sticky.getBoundingClientRect().height));
    var toasts = document.getElementById('toasts-container');
    var toastsHeight = toasts ? Math.round(toasts.getBoundingClientRect().height) : 0;
    if (toastsHeight > 32) lift += toastsHeight; // an empty container is just its padding
    box.style.setProperty('--paex-reminder-lift', lift + 'px');
    var top = 16;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (section) {
      var rect = section.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > 0) top = Math.max(top, Math.round(rect.bottom) + 12);
    });
    box.style.setProperty('--paex-reminder-top', Math.min(top, 240) + 'px');
  }

  var mobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var padSaved = null; // the page's own inline scroll-padding-bottom, restored on hide

  function padOn(box) {
    if (!mobile || !mobile.matches) return;
    var rect = box.getBoundingClientRect();
    if (!(rect.height > 0)) return;
    var root = document.documentElement;
    if (padSaved === null) padSaved = root.style.scrollPaddingBottom || '';
    root.style.scrollPaddingBottom = Math.max(0, Math.round(window.innerHeight - rect.top) + 8) + 'px';
  }

  function padOff() {
    if (padSaved === null) return;
    document.documentElement.style.scrollPaddingBottom = padSaved;
    padSaved = null;
  }

  function onKey(event) {
    if (event.key === 'Escape') hide();
  }

  function visible(node) {
    return Boolean(node && node.getClientRects().length);
  }

  function hide() {
    var box = el();
    document.removeEventListener('keydown', onKey);
    padOff();
    if (!box || box.hidden) return;
    var hadFocus = box.contains(document.activeElement);
    box.hidden = true;
    if (hadFocus) {
      var icon = document.getElementById('Cart-Icon-Bubble');
      var target = visible(icon) ? icon : document.getElementById('MainContent');
      if (target) target.focus();
    }
  }

  function show(text, withCta) {
    var box = el();
    if (!box) return;
    var link = document.querySelector('link[data-paex-reminder-css]');
    // never show unstyled: wait for the deferred stylesheet once
    if (link && !link.sheet) {
      link.addEventListener('load', function () { show(text, withCta); }, { once: true });
      return;
    }
    write('sessionStorage', 'paex:reminder:shown', '1');
    var cta = box.querySelector('[data-paex-reminder-open]');
    if (cta) cta.hidden = !withCta;
    place(box);
    box.hidden = false;
    padOn(box);
    document.removeEventListener('keydown', onKey); // never twice
    document.addEventListener('keydown', onKey);
    // fill the status region AFTER it is visible, so it is announced
    requestAnimationFrame(function () {
      var textEl = box.querySelector('[data-paex-reminder-text]');
      if (textEl) textEl.textContent = text;
    });
  }

  function decide() {
    var clock = window.paexClock;
    if (!clock || !clock.state || clock.state.phase === 'off') return;
    clock.estimate({ processing: slowestProcessing() }).then(function (result) {
      var verdict = result && result.verdict;
      if (verdict === 'ontime' || verdict === 'lastday') {
        var date = result.estimate && result.estimate.date; // same date as the PDP / cart box (Sasha 2026-10-09)
        if (date) show(clock.t('reminder', { date: clock.fmtDate(date) }), true);
      } else if (verdict === 'late') {
        // generic only: no store stock behind this note, so no store name
        show(clock.t('reminder_late_generic'), false);
      }
      // unknown → nothing
    }).catch(function () { /* no answer → no reminder */ });
  }

  function start() {
    var clock = window.paexClock;
    var config = clock && clock.config;
    if (!config || !config.flags || !config.flags.reminder) return;
    if (!(Number(config.cart && config.cart.count) > 0)) return;
    var box = el();
    if (!box) return;
    box.addEventListener('click', function (event) {
      if (event.target.closest('[data-paex-reminder-close]')) {
        hide();
        return;
      }
      if (event.target.closest('[data-paex-reminder-open]')) {
        hide();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show(document.getElementById('Cart-Icon-Bubble') || undefined);
        else window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
      }
    });
    // wait (≤ 3 s, the clock's own geo wait) until the destination settles
    if (!clock.state.pending) {
      decide();
      return;
    }
    var settle = function (event) {
      if (event.detail && event.detail.pending) return;
      document.removeEventListener('paex:clock-change', settle);
      decide();
    };
    document.addEventListener('paex:clock-change', settle);
  }

  if (window.paexClock) start();
  else document.addEventListener('paex:clock-ready', start, { once: true });
})();
